import BaseService from '@core/class/BaseService';

interface IVerifyShop {
  code: string;
  shopId?: string;
  mainAccountId?: string;
}

class MypageServices extends BaseService {
  public getSellerID = () => {
    return this.get('api/v1/seller/info');
  };
  public editAccount = (body: Record<string, any>) => {
    return this.put(`api/v1/seller/update-request`, body);
  };
  public uploadFile = (body: Record<string, any>) => {
    return this.post(`api/v1/seller/upload`, body);
  };
  public infoAmazon = () => {
    return this.get(`api/v1/seller/amazon/info`);
  };
  public showPopupAmazon = (body: Record<string, any>) => {
    return this.get(`api/v1/seller/webhook/amazon2`, body);
  };
  public startIntegration = (body: Record<string, any>) => {
    return this.get(`api/v1/seller/shopee-accounts/generate-url-authorization`, body);
  }
  public verifyShop = (body: IVerifyShop) => {
    return this.post(`api/v1/seller/shopee-accounts/verify-shop`, body);
  }
  public getIntergrationHistory = (body: Record<string, any>) => {
    return this.get(`api/v1/seller/marketplace-integration-histories`, body);
  }
  public updateAgreement = (body: Record<string, any>) => {
    return this.put(`api/v1/seller/update-agree-policy`, body);
  }

}
export default new MypageServices('/', true);
